import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { KeyWord } from 'src/app/shared/classes/constants';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ThemingService } from 'src/app/shared/services/theming.service';

@Component({
  selector: 'app-competitors-outline',
  templateUrl: './competitors-outline.component.html',
  styleUrls: ['./competitors-outline.component.scss']
})
export class CompetitorsOutlineComponent implements OnInit, OnDestroy {

  activateLink: string = 'Competitors Outline';
  SRTPPosition: number = 1;
  SRTPData = new Array(20);
  tableData: any[] = []
  sourceData = ['PAA', 'Quora', 'Reddit', 'Competitors', 'Strell'];
  source: number = 1;
  panelOpenState: boolean = false;
  visible: boolean = true
  outlineTagArray = KeyWord.outlineTagArray;
  masterSelected: boolean = false;
  checkboxCheck: boolean = false;
  addH2Tage:boolean = false;
  addH3Tage:boolean = false;
  theme: boolean = true;
  @Input() public outline?: any;
  @Input() public baseOutline?: any;
  @Input() public eid?: any;

  get className() {
    return !this.theme ? 'tag-menu' : ''
  }
  get menu() {
    return !this.theme ? 'providers-menu' : ''
  }
  compititorsData: any = [];
  newCompititorsOutline: any[] = [];
  baseOutlineData: any[] = [];
  currentDrag: any = {};
  h2Tag:string= ""
  h3Tag:string = '';
  uid:string = "";
  constructor(
    private themingService: ThemingService,
    private modal: NgbModal,
    private editorServide:EditorService,
    private cookieService:CookieService,
    public activeModal: NgbActiveModal,

  ) {
    // this.themingService.nameKeeper.subscribe(val => this.theme = val);
    this.themingService.getThemeName().subscribe((res: any) => {
      this.theme = res
    })
    // let data = this.compititorsData.map(e => e.level).lastIndexOf(2);
    // let data1:any = [];
    //   this.compititorsData.forEach((e,index)=>{
    //     if(index > data){
    //       data1.push(e);
    //     }
    //   })
    // this.compititorsData[data]['arr'] = data1;
    // console.log(this.compititorsData)    
  }

  ngOnInit(): void {
    this.themingService.pingThemeName();
    this.uid = this.cookieService.get('uid');
    let a = JSON.stringify(this.baseOutlineData);
    this.baseOutlineData = JSON.parse(a);
    for (let i = 0; i < 10; i++) {
      let data = { title: 'She was the type of girl who wanted to live in a pink house?', isChecked: false }
      this.tableData.push(data)
    }
    if(this.baseOutline?.length > 0) {
      this.baseOutlineData.push(...this.baseOutline);
    }
    this.getSerpData(0);
  }
  ngOnDestroy() {

  }
  getSerpData(position:any){
    this.compititorsData = this.outline[position];
    setTimeout(() => {
      this.calculateData();
    }, 200);
  }
  checkAll() {
    for (let i = 0; i < this.tableData.length; i++) {
      this.tableData[i].isChecked = this.masterSelected
    }
  }
  calculateData(){
    this.newCompititorsOutline = [];
    let parentTag = "h2";
    let parentIndex = 0;
    this.compititorsData.outline.forEach((e:any, index:any) => {
      this.compititorsData.outline[index]['arr'] = [];
      e['panelOpenState'] = false;
      let checkH2 = this.compititorsData.outline?.some((e:any)=>e.tag_name==="h2");
      if(!!checkH2) {
        if (this.compititorsData.outline[index].tag_name == parentTag) {
          parentTag == this.compititorsData.outline[index].tag_name;
          parentIndex = index
        }
        if (parentTag !== this.compititorsData.outline[index].tag_name && this.compititorsData.outline[index].tag_name !== "h1") {
          this.compititorsData.outline[parentIndex].arr.push(this.compititorsData.outline[index]);
        }
        if (this.compititorsData.outline[index].tag_name !== "h3") {
          this.newCompititorsOutline.push(e);
        }
      }else{
        this.newCompititorsOutline.push(e);
      }
     
    })
  }
  isAllSelected() {
    this.masterSelected = this.tableData.every((item: any) => {
      return item.isChecked == true;
    });
  }
  closeModal() {
    this.modal.dismissAll();
  }
  openMyMenu(menuTrigger: MatMenuTrigger) {
    menuTrigger.openMenu();
  }
  addAll(data: any) {
    let childArr = [...data.arr];
    let modifiedArr = JSON.stringify(data);
    let b = JSON.parse(modifiedArr);
    delete b.arr;
    let allData = [b, ...childArr]
    allData.forEach(e=>{
      e.isCheck = false;
      e.isEditable = true;
    })
    this.baseOutlineData.push(...allData);
    // this.sortArr();
  }
  add(data: any) {
    let modifiedArr = JSON.stringify(data);
    let b = JSON.parse(modifiedArr);
    this.baseOutlineData.push(b);
    this.baseOutlineData.forEach(e=>{
      e.isCheck = false;
      e.isEditable = true;
    })
    //  this.sortArr();
  }
  sortArr() {
    this.baseOutlineData.sort((a: any, b: any) => {
      if (b.level > a.level) {
        return -1;
      } else {
        return 1;
      }
    })
  }
  drag(ev: any, index: number) {
    ev.dataTransfer.setData("itemToMove", index);
    this.currentDrag = this.baseOutlineData[index];
    // document.getElementById(`div${index}`)!.style.borderTop = "";
  }

  drop(ev: any, index: number) {
    ev.preventDefault();
    var data = ev.dataTransfer.getData("itemToMove");
    // this.baseOutlineData.splice(index, 0, this.currentDrag);
    let numberOfDeletedElm = 1;

    const elm = this.baseOutlineData.splice(Number(data), numberOfDeletedElm)[0];

    numberOfDeletedElm = 0;

    this.baseOutlineData.splice(index, numberOfDeletedElm, elm);
    document.getElementById(`div${index}`)!.style.borderTop = "";
    // document.getElementById(`dragg${index}`)!.style.display = "none";
  }
  allowDrop(ev: any,index:number) {
    ev.preventDefault();
    document.getElementById(`div${index}`)!.style.borderTop = "1px solid blue";
    // document.getElementById(`dragg${index}`)!.style.display = "flex";
  }
  removeDrag(ev: any,index:number){
    ev.preventDefault();
    document.getElementById(`div${index}`)!.style.borderTop = "";
    // setTimeout(() => {
    //   document.getElementById(`dragg${index}`)!.style.display = "none";
    // }, 800);

  }
  dropTransfer(ev: any, index: number){
    ev.preventDefault();
    var data = ev.dataTransfer.getData("itemToMove");
    // this.baseOutlineData.splice(index, 0, this.currentDrag);
    let numberOfDeletedElm = 1;

    const elm = this.baseOutlineData.splice(Number(data), numberOfDeletedElm)[0];
    elm.tag_name="h2";
    numberOfDeletedElm = 0;

    this.baseOutlineData.splice(index, numberOfDeletedElm, elm);
    document.getElementById(`div${index}`)!.style.borderTop = "";
    // document.getElementById(`divv${index}`)!.innerHTML = document.getElementById(`div${index}`)!.innerHTML;
    // document.getElementById(`div${index}`)!.innerHTML = "";
  }
  dropTransfer1(ev: any, index: number){
    ev.preventDefault();
    var data = ev.dataTransfer.getData("itemToMove");
    // this.baseOutlineData.splice(index, 0, this.currentDrag);
    let numberOfDeletedElm = 1;

    const elm = this.baseOutlineData.splice(Number(data), numberOfDeletedElm)[0];
    elm.tag_name="h3";
    numberOfDeletedElm = 0;

    this.baseOutlineData.splice(index, numberOfDeletedElm, elm);
    document.getElementById(`div${index}`)!.style.borderTop = "";
    // document.getElementById(`divv${index}`)!.innerHTML = document.getElementById(`div${index}`)!.innerHTML;
    // document.getElementById(`div${index}`)!.innerHTML = "";
  }
  showDiv(index:any){
    document.getElementById(`dragg${index}`)!.style.display = "flex";
  }
  hideDiv(index:any){
    document.getElementById(`dragg${index}`)!.style.display = "none";
  }
  saveData(){
    this.activeModal.close(this.baseOutlineData);
  }
  addTag(tagName:string){
    let obj={
      level:tagName==='h2'? 2 : 3,
      tag_name:tagName,
      tag_value:tagName==='h2' ? this.h2Tag : this.h3Tag
    }
    this.baseOutlineData.push(obj)
    // this.editorServide.postBaseOutline({aid:this.eid,baseOutlineData:JSON.stringify(this.baseOutlineData)}).subscribe(res=>{
    //   // this.getEditorDatas();
      this.h2Tag="";
      this.h3Tag="";
    // })
  }
  deleteTag(index:number){
    this.baseOutlineData.splice(index,1)
  }
  // renameTag(index:number,event?:any){
  //   event?.preventDefault();
  //   // document.getElementById(`editDiv${index}`)!.contentEditable = "true";
  //   this.baseOutlineData[index].tag_value = document.getElementById(`editDiv${index}`)!.innerText;
  // }
  editTag(index:number,event?:any){
    event?.preventDefault();
    // document.getElementById(`editDiv${index}`)!.contentEditable = "true";
    this.baseOutlineData[index].tag_name = document.getElementById(`editTag${index}`)!.innerText?.toLowerCase();
  }
  saveTag(index:number){
    var parentDiv =(document.getElementById(`parentEditt${index}`)as any);
    var div =  (document.getElementById(`editDivv${index}`)as any);
    parentDiv.style.background = "";
    parentDiv.style["boxShadow"] = "";
    parentDiv.style.borderRadius = '0'; // standard
    parentDiv.style.padding = '0'; // standard
    div!.contentEditable="false";
    this.baseOutlineData[index].tag_value = document.getElementById(`editDivv${index}`)!.innerText;
    this.baseOutlineData[index].isEditable = true;
    this.baseOutlineData[index].isCheck = false;
  }
  renameTag(index:number){
    var parentDiv =(document.getElementById(`parentEditt${index}`)as any);
   var div =  (document.getElementById(`editDivv${index}`)as any);
   parentDiv.style.width="100%"
   parentDiv.style.background = "white";
   parentDiv.style["boxShadow"] = "0 0 5px #999999";
   parentDiv.style.borderRadius = '10px'; // standard
   parentDiv.style.padding = '5px'; // standard
   div!.contentEditable="true";
   div?.focus();
    this.baseOutlineData[index].isEditable = false;
    this.baseOutlineData[index].isCheck = true;
  //   // document.getElementById(`editDiv${index}`)!.contentEditable = "true";
  }
  addH2(){
    document.getElementById('h2Tag')!.style.color = "blue"
    setTimeout(() => {
      document.getElementById('h2Tag')!.style.color = ""

    }, 250);
    this.baseOutlineData.push({tag_name:"h2",tag_value:"",level:2,isCheck:false,isEditable:true});
  }
  addH3(){
    document.getElementById('h3Tag')!.style.color = "blue"
    setTimeout(() => {
      document.getElementById('h3Tag')!.style.color = ""

    }, 250);
    this.baseOutlineData.push({tag_name:"h3",tag_value:"",level:3,isCheck:false,isEditable:true});
  }
  renameTagName(index:number,arg:string){
    this.baseOutlineData[index].tag_name=arg;
  }
}

